import { SiteUrls } from '@tableau/shared-urls';
import { ThumbnailProps } from '../../app/spaces/CardView/Thumbnail';
import { Messages } from '../../codegen/Localize';
import { Module } from '../Module';
import { AdminInsightsCreateProjectRequest } from '../ServerApi/requests/AdminInsightsCreateProjectRequest';
import { AdminInsightsDeleteProjectRequest } from '../ServerApi/requests/AdminInsightsDeleteProjectRequest';
import { AdminInsightsGetProjectStatusRequest } from '../ServerApi/requests/AdminInsightsGetProjectStatusRequest';
import { IAdminInsightsResult } from '../ServerApi/types/IAdminInsightsResult';
import { BrowserTitleService } from '../services/BrowserTitleService';
import { ConfirmActionDialog } from '../services/ConfirmActionDialog';
import { HelpService } from '../services/HelpService';
import { ServerService } from '../services/ServerService';
import { ToasterService, ToastType } from '../services/ToasterService';

export interface IAdminSiteStatusScope extends ng.IScope {
  hideStatsForLoadTimes: () => boolean;
  hidePerformanceofViews: () => boolean;
  hidePerformanceofFlowRunsOnSite: () => boolean;
  bridgeEnabled: () => boolean;
  isAdminDataSourceEnabled: boolean;
  processingState: string;
  createAdminInsightsProject: () => void;
  deleteAdminInsightsProject: () => void;
  thumbnailProps: ThumbnailProps;
  learnMoreHref: string;
  projectId: string;
  analysisUrl: (sheetUrlId: string) => string;
}

export class AdminSiteStatusCtrl {

  public static $inject = [
    '$scope',
    'ServerService',
    'BrowserTitleService',
    'ConfirmActionDialog',
    'ToasterService',
    'HelpService',
 ];

  constructor(
    private $scope: IAdminSiteStatusScope,
    server: ServerService,
    BrowserTitleService: BrowserTitleService,
    confirmActionDialog: ConfirmActionDialog,
    toaster: ToasterService,
    private help: HelpService
  ) {

    const siteUrls = new SiteUrls({
      siteUrlName: server.sessionSiteUrlName(),
      queryString: window.location.search
    });

    BrowserTitleService.setTitleWithPlace({translatablePlaceName: 'siteStatus'});

    $scope.hideStatsForLoadTimes  = () => {
      return server.hideAdminVizStatsForLoadTimes();
    };

    $scope.hidePerformanceofViews  = () => {
      return server.hideAdminVizPerformanceofViews();
    };

    $scope.hidePerformanceofFlowRunsOnSite  = () => {
      return server.hideAdminVizPerformanceofFlowRunsOnSite();
    };

    $scope.bridgeEnabled = () => server.isBridgeEnabled();

    $scope.analysisUrl = (sheetUrlId: string) => {
      return siteUrls.siteStatusVizUrl(sheetUrlId);
    };

    //Start of Admin Insights code..........
    if(server.isAdminDataSourceEnabled()){
      server.sendRequest(new AdminInsightsGetProjectStatusRequest()).
      then((result: IAdminInsightsResult) => {
        if(this.updateScopeFromServerResponseAndReturnSuccessStatus(result)){
          $scope.thumbnailProps = {
            navigateUrl: siteUrls.projectUrl($scope.projectId),
            defaultImageUrl: 'img/project-thumb-2.png',
            imageCoverBackground: true,
            name: Messages.adminInsightsProjectName(),
          };
        }
      }
    );}

    $scope.createAdminInsightsProject = () => {
      confirmActionDialog.open({
        title: Messages.adminInsightsCreateProjectConfirmTitle(),
        bodyText: Messages.adminInsightsCreateProjectConfirmMsg(),
        actionName: Messages.createTemplateResultDialogButtonOK(),
        action: () => {
          return server.sendRequest(new AdminInsightsCreateProjectRequest()).
          then((result: IAdminInsightsResult) => {
            if(this.updateScopeFromServerResponseAndReturnSuccessStatus(result)){
              const successMsg = Messages.adminInsightsToastSuccessMsg();
              toaster.pop({ type: ToastType.Info, text: successMsg });
            }else{
              const errorMsg = Messages.adminInsightsOptInErrorMsg();
              toaster.pop({ type: ToastType.Error, text: errorMsg});
            }
          });
        }
      });
    };

    $scope.deleteAdminInsightsProject = () => {
      confirmActionDialog.open({
        title: Messages.adminInsightsDeleteConfirmTitle(),
        bodyText: Messages.adminInsightsDeleteConfirmMsg(),
        actionName: Messages.adminInsightsDeleteConfirmTitle(),
        isDeleteAction: true,
        action: () => {
          return server.sendRequest(new AdminInsightsDeleteProjectRequest()).
          then((result: IAdminInsightsResult) => {
            if(!this.updateScopeFromServerResponseAndReturnSuccessStatus(result)){
              const errorMsg = Messages.adminInsightsOptOutErrorMsg();
              toaster.pop({ type: ToastType.Error, text: errorMsg});
            }
          });
        }
      });
    };
  }

  // boolean represent if there is any error on server side while processing the request.
  private updateScopeFromServerResponseAndReturnSuccessStatus(result: IAdminInsightsResult): boolean {
    if (!result || !result.processingState) {
      return false;
    }
    if (!result.responseCode || result.responseCode !== 200) {
      return false;
    }

    this.$scope.processingState = '' + result.processingState;
    this.$scope.projectId = '' + result.projectId;
    //after error checks .. disable all the flags..
    if (result.processingState === 'completed' ||
      result.processingState === 'inprogress' ||
      result.processingState === 'notExists') {
      this.$scope.isAdminDataSourceEnabled = true;
      this.$scope.learnMoreHref = this.help.getServerHelpUrlByCategory('insights');
      return true;
    } else {
      this.$scope.isAdminDataSourceEnabled = false;
      return false;
    }
  }

}
Module.instance().controller('AdminSiteStatusCtrl', AdminSiteStatusCtrl);
